document.addEventListener('DOMContentLoaded', ()=> {
  class customClose extends HTMLElement {

    constructor(){
        super();
        this.close = this.querySelector('span');
        
        if(this.close) {
          this.close.addEventListener('click', e => {
            e.stopPropagation();
            e.preventDefault();
            this.setLocalStorage(this.dataset.index);
            OpenBanner.classList.remove('open');
          });
        }

        this.init(this.dataset.index);

      }

      init(index) {
        if(localStorage.getItem(index) != null) {
            this.closest('.announcement-bar').remove();
        }
      }

      setLocalStorage(index) {
        localStorage.setItem(index, 'true');
      }
  }

  const OpenBanner = document.querySelector('.announcement-bar');
  setTimeout(() => {
    OpenBanner.classList.add('open');
  }, "1000");
  
  customElements.define('custom-close', customClose);
});

